// Tags
const TAG_MAH = "MAH";

export default {
    TAG_MAH,
    tags: [
        {
            name: "Make and Hold",
            value: TAG_MAH,
            icon: "mdi-package-variant-closed-check",
            colour: "deep-purple-lighten-1",
        }
    ],
}
